import React from 'react';

import { Stack, Typography } from '@gogame/components';
import { FormField, FormFieldArray, FormErrorMessage } from '@gogame/form';
import { dateFNS } from '@gogame/intl-ts';

import { ON_DATE, EVERY, AT_TIME, DAYS_LIST, DAYS } from './constants';

export const OnDateFiled = () => (
  <Stack direction={'row'} spacing={1} alignItems={'center'}>
    <Typography>on</Typography>
    <Stack>
      <FormField.DatePicker
        name={ON_DATE}
        minDate={dateFNS.startOfDay(new Date())}
        _cleanOnUnmount={true}
        timeZone={'local'}
        padding={'0'}
      />
    </Stack>
  </Stack>
);

export const EveryHoursField = () => {
  const validationEveryHours = (value) => {
    if (!value) {
      return 'required';
    }
  };

  return (
    <Stack direction={'row'} spacing={1} alignItems={'center'} width={'150px'}>
      <Typography>every</Typography>
      <Stack>
        <FormField.TextField
          label={'Hour(s)'}
          name={EVERY}
          validate={validationEveryHours}
          _cleanOnUnmount={true}
          type={'number'}
          padding={'0'}
        />
      </Stack>
    </Stack>
  );
};

export const AtTimeField = () => (
  <Stack direction={'row'} spacing={2} alignItems={'center'}>
    <Typography>at</Typography>
    <Stack
      style={{
        width: 100,
      }}
    >
      <FormField.TimeInput
        placeholder={'00:00'}
        name={AT_TIME}
        lazy={true}
        _cleanOnUnmount={true}
        padding={'0'}
      />
    </Stack>
  </Stack>
);

export const DaysField = () => {
  return (
    <Stack direction={'column'} spacing={1}>
      <Stack direction={'row'} spacing={1} alignItems={'center'}>
        <FormFieldArray name={DAYS}>
          {() =>
            DAYS_LIST.map(({ id, name }, i) => (
              <FormField.Checkbox
                key={id}
                label={name}
                name={`${DAYS}[${i}]${id}`}
                lazy={true}
                _cleanOnUnmount={true}
                padding={'0'}
              />
            ))
          }
        </FormFieldArray>
      </Stack>
      <FormErrorMessage name={DAYS} />
    </Stack>
  );
};
